import type { CreateNoteRequest, CustomerNote, UpdateNoteRequest } from '@/types/customer-note';

/**
 * Demo-mode fabricated response for adding a customer note.
 * Used as the demoFn for useAddCustomerNote.
 */
export function addCustomerNoteDemoResponse(
  request: CreateNoteRequest & { userId: string; userName: string },
): CustomerNote {
  return {
    id: String(Date.now()),
    customerId: request.customerId,
    content: request.content,
    createdAt: new Date().toISOString(),
    createdBy: {
      id: request.userId,
      name: request.userName,
    },
  };
}

/**
 * Demo-mode fabricated response for editing a customer note.
 * Used as the demoFn for useUpdateCustomerNote.
 */
export function updateCustomerNoteDemoResponse(request: UpdateNoteRequest): CustomerNote {
  return {
    id: request.noteId,
    customerId: request.customerId,
    content: request.content,
    createdAt: new Date().toISOString(),
    createdBy: {
      id: '',
      name: 'Current User',
    },
  };
}
